import { render, staticRenderFns } from "./vonestis.vue?vue&type=template&id=ab7ecd7a&scoped=true&"
import script from "./vonestis.vue?vue&type=script&lang=js&"
export * from "./vonestis.vue?vue&type=script&lang=js&"
import style0 from "./vonestis.vue?vue&type=style&index=0&id=ab7ecd7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7ecd7a",
  null
  
)

/* custom blocks */
import block0 from "./vonestis.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports